import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Copy, Link2, FileText, Sparkles } from 'lucide-react';
import api from '../../api/client';
import { useAuth } from '../../context/AuthContext';
import { puoFare } from '../../utils/permessi';
import { MODELLO_OPEN_DAY } from '../../utils/formCampi';

// Elenco dei form pubblici (permesso "form").
export const STATO_COLORI = { BOZZA: '#888', APERTO: '#22C55E', CHIUSO: '#EF4444' };
export const linkPubblico = (slug) => `${window.location.origin}/f/${slug}`;

export default function FormLista() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const puoCreare = puoFare(user, 'form', 'create');
  const [forms, setForms] = useState(null);
  const [copiato, setCopiato] = useState(null);

  useEffect(() => { api.get('/form').then(r => setForms(r.data)).catch(() => setForms([])); }, []);

  const crea = async (base) => {
    try {
      const r = await api.post('/form', base);
      navigate(`/form/${r.data.id}`);
    } catch (e) { alert(e.response?.data?.error || 'Errore'); }
  };
  const copia = async (f) => {
    try { await navigator.clipboard.writeText(linkPubblico(f.slug)); setCopiato(f.id); setTimeout(() => setCopiato(null), 1500); }
    catch { window.prompt('Copia il link:', linkPubblico(f.slug)); }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px', flexWrap: 'wrap', marginBottom: '20px' }}>
        <div>
          <div style={s.title}>FORM</div>
          <div style={s.sub}>Moduli con link pubblico: iscrizioni open day, richieste, raccolta documenti.</div>
        </div>
        {puoCreare && <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          <button style={s.btnSec} onClick={() => crea(MODELLO_OPEN_DAY())}><Sparkles size={14} /> MODELLO OPEN DAY</button>
          <button style={s.btnPri} onClick={() => crea({ titolo: 'Nuovo form', campi: [] })}><Plus size={14} /> NUOVO FORM</button>
        </div>}
      </div>

      {forms === null && <div style={s.vuoto}>Caricamento…</div>}
      {forms?.length === 0 && <div style={s.vuoto}>
        <FileText size={28} style={{ opacity: 0.4 }} />
        <div>Nessun form ancora.{puoCreare ? ' Parti dal modello open day o da un form vuoto.' : ''}</div>
      </div>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {forms?.map(f => (
          <div key={f.id} style={s.riga} onClick={() => navigate(`/form/${f.id}`)}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.titolo}</div>
              <div style={s.meta}>{f.n_campi} domande · {f.n_risposte} risposte{f.genera_codice ? ' · con codice' : ''}{f.collega_anagrafica ? ' · collegato all\'anagrafica' : ''}</div>
            </div>
            <span style={{ ...s.badge, color: STATO_COLORI[f.stato], borderColor: STATO_COLORI[f.stato] + '60' }}>{f.stato}</span>
            {f.stato !== 'BOZZA' && <button style={s.btnSec} onClick={e => { e.stopPropagation(); copia(f); }} title={linkPubblico(f.slug)}>
              {copiato === f.id ? <><Copy size={13} /> COPIATO</> : <><Link2 size={13} /> LINK</>}
            </button>}
          </div>
        ))}
      </div>
    </div>
  );
}

export const s = {
  title: { fontFamily: "'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight: '800', letterSpacing: '2px' },
  sub: { color: 'var(--text-dim)', fontSize: 'var(--font-size-sm)', marginTop: '4px' },
  riga: { display: 'flex', alignItems: 'center', gap: '12px', background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '10px', padding: '14px 16px', cursor: 'pointer' },
  meta: { fontSize: 'var(--font-size-xs)', color: 'var(--text-dim)', marginTop: '3px' },
  badge: { padding: '2px 8px', borderRadius: '4px', border: '1px solid', fontSize: 'var(--font-size-xs)', fontWeight: '700', letterSpacing: '1px', whiteSpace: 'nowrap' },
  vuoto: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', color: 'var(--text-dim)', fontSize: 'var(--font-size-sm)', padding: '40px', background: 'var(--bg-card)', border: '1px dashed var(--border2)', borderRadius: '12px', textAlign: 'center' },
  card: { background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '12px', padding: '18px', marginBottom: '14px' },
  cardTitle: { fontSize: 'var(--font-size-xs)', fontWeight: '700', letterSpacing: '2px', color: '#F4600C', marginBottom: '12px' },
  label: { display: 'block', fontSize: 'var(--font-size-xs)', fontWeight: '700', letterSpacing: '1px', color: 'var(--text-dim)', marginBottom: '4px' },
  inp: { width: '100%', background: 'var(--bg-input)', border: '1px solid var(--border2)', borderRadius: '8px', padding: '9px 12px', color: 'var(--text)', fontSize: 'var(--font-size-sm)', outline: 'none', boxSizing: 'border-box' },
  help: { fontSize: 'var(--font-size-xs)', color: 'var(--text-dim)', lineHeight: 1.6, margin: '4px 0 0' },
  errore: { background: '#EF444420', border: '1px solid #EF444440', borderRadius: '8px', padding: '8px 12px', color: '#EF4444', fontSize: 'var(--font-size-sm)', marginBottom: '12px' },
  btnPri: { display: 'flex', alignItems: 'center', gap: '6px', background: '#F4600C', color: '#fff', border: 'none', borderRadius: '8px', padding: '9px 14px', fontSize: 'var(--font-size-xs)', fontWeight: '700', cursor: 'pointer', whiteSpace: 'nowrap' },
  btnSec: { display: 'flex', alignItems: 'center', gap: '6px', background: 'var(--bg-input)', color: 'var(--text-muted)', border: '1px solid var(--border2)', borderRadius: '8px', padding: '8px 12px', fontSize: 'var(--font-size-xs)', fontWeight: '700', cursor: 'pointer', whiteSpace: 'nowrap' },
  iconBtn: { background: 'transparent', border: 'none', color: 'var(--text-dim)', cursor: 'pointer', padding: '4px', display: 'flex' },
  tab: { background: 'transparent', border: 'none', borderBottom: '2px solid transparent', color: 'var(--text-dim)', padding: '10px 4px', fontSize: 'var(--font-size-xs)', fontWeight: '700', letterSpacing: '1.5px', cursor: 'pointer' },
};
